<template>
    <div
        class="o-p-floor-list"
        :style="{...componentStyles, ...aPListHeaderParams.style, ...aPListItemParams.style}"
        ref="posterList"
    >
        <div
            v-for="(floor, index) in floors"
            :key="floor.id"
            class="o-p-floor-list__floor-wrapper"
            :class="{
                'o-p-floor-list__floor-wrapper--active': isActiveFloor(floor.id),
            }"
        >
            <APListHeader
                :key="floor.id + index"
                :title="t(floor, 'name')"
                :params="aPListHeaderParams.params"
                :class="{
                    'a-p-list-header--active': isActiveFloor(floor.id),
                    'a-p-list-header--short': floor.short
                }"
            >
                <template>
                    <div class="a-p-list-header__service-icon-wrapper">
                        <img 
                            class="a-p-list-header__service-icon"
                            v-for="service in getFloorServices(floor.id)"
                            :key="service.id"
                            :src="service.files.icon" 
                            alt="service icon"
                        >
                    </div>
                </template>
                <template #title-icon>
                    <div 
                        v-if="isActiveFloor(floor.id) && !componentParams.is_show_here_icon_in_end"
                        class="a-p-list-header__info-here"
                    >
                        <div 
                            class="a-p-list-header__info-here-inside"
                        >
                        </div>
                        <div 
                            class="a-p-list-header__info-here-text"
                            v-html="$t(componentParams.du_ar_har, 'Du er </br> her')"
                        ></div>
                    </div>
                </template>
            </APListHeader>
            <div
                :key="floor.id + index + 'i'"
                class="tenants-wrapper"
                :style="{...getListStyle(getFloorTenants(floor.id), isFloorShort(floor)), ...listItemComputedStyle}"
            >
                <APListItem
                    v-for="(tenant, i) in getFloorTenants(floor.id)"
                    :key="tenant.id + 'i' + index"
                    :title="tenant.meta[`name_${locale}`] || tenant.meta.name"
                    :dark="checkDarckItem(i, getFloorTenantsLenght(floor.id))"
                    :class="{
                        'a-p-list-item--short': floor.short
                    }"
                    :isCapitalise="isCapitaliseListItemTitle"
                >
                    <template>
                        <span></span>
                    </template>
                </APListItem>
                <div 
                    class="o-p-floor-list__active-floor-icon"
                    v-if="isActiveFloor(floor.id) && componentParams.is_show_here_icon_in_end"
                />
            </div>
        </div>
        <OPQrWidget
            v-if="isShowQrWidget"
        />
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex'

import OPQrWidget from '../o-p-qr-widget/o-p-qr-widget'
import APListItem from '../../atoms/a-p-list-item/a-p-list-item'
import APListHeader from '../../atoms/a-p-list-header/a-p-list-header'

import {reportWarning} from "@/utils/helpers/health-monitoring";

export default {
    name: 'OPFloorList',
    components: {
        OPQrWidget,
        APListItem,
        APListHeader
    },
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            columnCount: null,
            aPListItemParams: {},
            listItemHeight: null,
            aPListHeaderParams: {},
            checkSizeTimeout: null,
            adjustListHeightTimeout: null
        }
    },
    computed: {
        ...mapState({
            locale: state => state.activeLocale
        }),
        ...mapGetters([
            't',
            'getFloors',
            'getTerminal',
            'getTerminalId',
            'getActiveLocale',
            'getCategoryById',
            'getMapConfigProp',
            'getDenormalisedTerminal',
            'getPosterBindingTenants',
            'getPosterBindingServices',
            'getDenormalisedObjectById'
        ]),
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPFloorList.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.OPFloorList.styles`) || {};
        },
        componentStyles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPFloorList.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.OPFloorList.params`) || {};
        },
        componentParams() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        floors() {
            if(this.mapedFloorProps.length) {
                return this.mapedFloorProps
            }
            return this.getFloors
        },
        mapedFloorProps() {
            if(this.floorProps) {
                return this.floorProps.map(floor => {
                    let floorInfo = this.getDenormalisedObjectById(floor.id)
                    if(!this.t(floorInfo, 'name')) {
                        floorInfo = {...floor, name: floor.id}
                    }
                    return {...floorInfo, ...floor}
                })
            }
            return []
        },
        floorProps() {
            if(this.componentParams.floors) return this.componentParams.floors
            return []
        },
        isShowQrWidget() {
            if (this.componentParams.hasOwnProperty('is_show_qr_widget') ) {
                return this.componentParams.is_show_qr_widget
            }

            return true
        },
        activeFloorId() {
            return this.mapedFloorProps.find(floor => floor.active)?.id
        },
        isCapitaliseListItemTitle() {
            return this.componentParams.is_capitalise_list_item_title
        },
        parentPosterId() {
            return this.getTerminal?.meta?.parrent_poster
        },
        listStyle() {
            return {
                columnCount: this.columnCount,
            }
        },
        minListItemHeight() {
            const minListItemHeight = this.componentParams.min_list_item_height
            if(minListItemHeight) {
                return this.extractNumber(`${minListItemHeight}`).itemHeight
            }

            return false
        },
        maxListItemHeight() {
            const maxListItemHeight = this.componentParams.max_list_item_height
            if(maxListItemHeight) {
                return this.extractNumber(`${maxListItemHeight}`).itemHeight
            }

            return false
        },
        isActivateAdjustListItemHeight() {
            return this.componentParams.is_activate_adjust_list_item_height
        },
        listItemComputedStyle() {
            return {
                '--a-p-list-item-height': this.listItemHeight
            }
        },
        isActivateChangeColumnsCount() {
            return this.componentParams.is_activate_change_columns_count
        }
    },
    methods: {
        getComponentsParams(componentName) {
            return {
                style: {
                    ...this.getMapConfigProp(`components.${componentName}.styles`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.styles`)
                },
                params: {
                    ...this.getMapConfigProp(`components.${componentName}.params`),
                    ...this.getMapConfigProp(`views.${this.view}.${componentName}.params`)
                }
            }
        },
        getFloorServices(id) {
            if(this.floorProps) {
                const bindingServices = this.getBindingServices(id);

                const floor = this.floorProps.find(floor => floor.id == id)
                const servicesFromConfig = floor?.services ? floor?.services.map(serviseId => this.getCategoryById(serviseId)) : []
                return this.sortedObjects([...servicesFromConfig, ...bindingServices])
            }
            return []
        },
        getFloorTenants(id) {
            if(this.floorProps) {
                const floor = this.floorProps.find(floor => floor.id == id);
                const tenantsFroomPosterConfig = floor?.tenants ? floor?.tenants.map(tenantId => {
                    const tenant = this.getDenormalisedObjectById(tenantId)
                    if(tenant?.id) {
                        return tenant
                    } else {
                        return {
                            id: tenantId,
                            meta: {
                                name: tenantId
                            }
                        }
                    }}) : []
                
                const bindingTenants = this.getBindingTenants(id);

                return this.sortedObjects([...tenantsFroomPosterConfig, ...bindingTenants])
            }
            return []
        },
        isActiveFloor(floorId) {
            if(this.activeFloorId == floorId) {
                return true
            }
            const terminal = this.getDenormalisedObjectById(this.getTerminalId)

            return terminal.floor.id === floorId
        },
        getBindingTenants(floorId) {
            let bindingTenants = [
                ...this.getPosterBindingTenants(this.getTerminalId),
                ...(this.parentPosterId ? this.getPosterBindingTenants(this.parentPosterId) : [])
            ]
            const floorLevel = this.getDenormalisedObjectById(floorId);

            if(floorLevel?.id) {
                bindingTenants = bindingTenants.filter(tenant => tenant.floor.level == floorLevel.floor.level) || []
            } else {
                bindingTenants = bindingTenants.filter(tenant => {
                    const tenantFloorLevel = tenant?.floor?.level ? tenant.floor.level : 1;
                    return floorId.includes(tenantFloorLevel)
                }) || []
            }

            return bindingTenants
        },
        getBindingServices(floorId) {
            let bindingServices = [
                ...this.getPosterBindingServices(this.getTerminalId),
                ...(this.parentPosterId ? this.getPosterBindingServices(this.parentPosterId) : [])
            ];
            const floorLevel = this.getDenormalisedObjectById(floorId);

            if(floorLevel?.id) {
                bindingServices = bindingServices.filter(tenant => tenant.floor.level == floorLevel.floor.level) || []
            } else {
                bindingServices = bindingServices.filter(tenant => {
                    const tenantFloorLevel = tenant?.floor?.level ? tenant.floor.level : 1;
                    return floorId.includes(tenantFloorLevel)
                }) || []
            }

            return bindingServices
        },
        sortedObjects(objects) {
            return objects
                .sort((a, b) => this.t(a, "name").localeCompare(this.t(b, "name"), this.getActiveLocale))
                .map((obj, i) => {
                    return {
                        ...obj, 
                        meta: {
                            ...obj.meta, 
                            order_in_poster: obj.meta.order_in_poster ? obj.meta.order_in_poster : 99
                        }
                    }
                })
                .sort((a, b) => +a.meta.order_in_poster >= +b.meta.order_in_poster ? 1 : -1)
        },
        checkListSize() {
            const posterListWrapper = this.$refs.posterList
            if(posterListWrapper) {
                const listRects = posterListWrapper.getBoundingClientRect();
                const items = Array.from(posterListWrapper.querySelectorAll('div.o-p-floor-list__floor-wrapper'))
                const lastItem = items.pop();
                const lastItemRect = lastItem.getBoundingClientRect();

                if(listRects.bottom < lastItemRect.bottom || listRects.right < lastItemRect.left ) {
                    const placedItems = items.filter(item => {
                        const itemRect = item.getBoundingClientRect()

                        return listRects.bottom > itemRect.top && listRects.right > itemRect.left
                    })
                    const msg = `; Poster name - ${this.t(this.getDenormalisedTerminal, 'name')}; Poster id - ${this.getTerminalId}; ${items.length - placedItems.length} objects not fit`;
                    reportWarning(msg);
                }
            }
        },
        isFloorShort(floor) {
            const configFloor = this.floorProps.find(f => f.id === floor.id)

            return configFloor ? configFloor.short : false
        },
        getListStyle(list, isShort) {
            if(list.length < 2 || isShort) {
                return {}
            } else {
                return this.listStyle
            }
        },
        checkDarckItem(index, arrLenght) {
            if(this.columnCount == 1) {
                return index % 2 !== 0
            }
            if(arrLenght < 3) {
                return false
            }
            if(arrLenght/2 <= 2 || arrLenght/2 % 2 == 0) {
                return index % 2 !== 0
            } else {
                if(index + 1 <= arrLenght/2) {
                    return index % 2 !== 0
                } else {
                    return index % 2 !== 0
                }
            }
        },
        getFloorTenantsLenght(id) {
            return this.getFloorTenants(id).length
        },
        adjustListHeight() {
            const listEl = this.$refs.posterList
            
            const items = Array.from(listEl.querySelectorAll('div.o-p-floor-list__floor-wrapper'))
            const listItemEl = items.pop();

            if(!listItemEl) {
                this.adjustListHeightTimeout = setTimeout(() => {
                    this.adjustListHeight()
                }, 300)
            } else {
                const listRect = listEl.getBoundingClientRect()
                const listElemRect = listItemEl.getBoundingClientRect()
                
                if(listRect.bottom < listElemRect.bottom || listRect.right < listElemRect.left ) {
                    this.changeListItemHeight();

                    this.adjustListHeightTimeout = setTimeout(() => {
                        this.adjustListHeight()
                    }, 300)
                } else {
                    this.checkListItemHeight()
                }
            }
        },
        extractNumber(str) {
            if(!str) return ''
            const match = str.match(/^(\d+(\.\d+)?)([a-zA-Z%]+)?$/);
            return match ? { itemHeight: parseFloat(match[1]), size: match[3] || '' } : null;
        },
        changeListItemHeight() {
            const lineHeightData = this.extractNumber(this.listItemHeight);
            if(!lineHeightData) return
            const itemHeight = lineHeightData.itemHeight;
            const newItemHeight = (itemHeight - itemHeight*0.02);

            if(this.isActivateChangeColumnsCount && this.minListItemHeight && newItemHeight < this.minListItemHeight) {
                this.changeColumnCount()
            } else {
                this.listItemHeight = newItemHeight + lineHeightData.size
            }
        },
        changeColumnCount() {
            if(this.columnCount < 2) {
                this.listItemHeight = this.aPListItemParams.style['--a-p-list-item-height']; 
                ++this.columnCount;
            }
        },
        checkListItemHeight() {
            const msg = `; Poster name - ${this.t(this.getDenormalisedTerminal, 'name')}; Poster id - ${this.getTerminalId};`;

            if(this.minListItemHeight && this.listItemHeight < this.minListItemHeight) {
                reportWarning(msg + 'List item height too small');
            }
            if(this.maxListItemHeight && this.listItemHeight > this.maxListItemHeight) {
                reportWarning(msg + 'List item height too big');
            }
        }
    },
    mounted() {
        this.aPListItemParams = this.getComponentsParams('APListItem')
        this.aPListHeaderParams = this.getComponentsParams('APListHeader')
        this.listItemHeight = this.aPListItemParams.style['--a-p-list-item-height'];
        this.columnCount = +this.componentParams?.columnCount || 1;
        this.checkSizeTimeout = setTimeout(() => {
            this.checkListSize()
            if(this.isActivateAdjustListItemHeight) this.adjustListHeight()
        }, 30000)
    },
    beforeDestroy() {
        if(this.checkSizeTimeout) clearTimeout(this.checkSizeTimeout)
        if(this.adjustListHeightTimeout) clearTimeout(this.adjustListHeightTimeout)
    }
}
</script>

<style lang="scss">
@import "o-p-floor-list";
</style>
